import {
	SET_TECHNICIANSKILLS,
	SET_SKILLSETS_RESULT,
	SET_RATELEVELS,
	SET_TECHNICIAN_DETAILS,
	ADD_SKILL_TO_EMPLOYEE,
	REMOVE_SKILL_FROM_EMPLOYEE,
	ADD_RATE_TO_EMPLOYEE,
	CLEAR_DATA_FROM_EMPLOYEE,
	SET_SEARCHLISTRESULTS,
	CLEAR_SEARCHLISTRESULTS,
	SET_SEARCHRESULTS,
	SET_SELECTEDTECHNICIANS,
	CLEAR_SELECTEDTECHNICIANS,
	UPDATE_SELECTEDTECHNICIANS,
	SORT_POSITIONS,
	ADD_INFO_TECHNICIAN_RATE,
	SET_BULKTRANSACTIONPROCESSING,
	UPDATE_TECHNICIANSKILLS_SKILLLEVELS,
	UPDATE_TECHNICIANSKILLS_SKILLLEVELS_BULK,
	SET_UNSAVED_BULK_ITEMS,
	SET_SAVED_BULK_ITEMS,
	SET_SKILLSETS_BULK_ITEMS,
	CLEAR_UNSAVED_BULK_ITEMS,
	CLEAR_SAVED_BULK_ITEMS,
	CLEAR_SKILLSETS_BULK_ITEMS,
	SET_ERROR_MESSAGE_BULK_ITEMS,
	CLEAR_ERROR_MESSAGE_BULK_ITEMS,
	CLEAR_SAVEDTECHNICIANS_BULK_ITEMS,
	ADD_DEFAULT_HOURLY_RATE_TO_EMPLOYEE
} from './technician-skills-mutation-types';
import api from '@/services/api-service';
import buildRoute from '@/composables/build-route';
import { filterItems } from './technician-skills-utils-functions';
import { areEqualElements } from '@/utils/object-functions';
import { cloneDeep, unionBy } from 'lodash';

export default {
	strict: process.env.NODE_ENV !== 'production',
	name: 'techManagementSkills',
	namespaced: true,
	state: {
		skillSets: { skillSets: [] },
		rateLevels: {},
		technicianDetails: {},
		technicianSkills: {},
		searchListResults: [],
		searchResults: [],
		selectedTechnicians: [],
		bulkTransactionProcessing: false,
		unsavedBulkItems: [],
		savedBulkItems: [],
		skillSetsBulkItems: [],
		errorMessageList: null
	},
	mutations: {
		[SET_SKILLSETS_RESULT](state, skillSets) {
			state.skillSets = skillSets;
		},
		[SET_TECHNICIANSKILLS](state, technicianSkills) {
			state.technicianSkills = technicianSkills;
		},
		[SET_RATELEVELS](state, rateLevels) {
			state.rateLevels = rateLevels;
		},
		[SET_TECHNICIAN_DETAILS](state, technicianDetails) {
			state.technicianDetails = technicianDetails;
			state.technicianDetails.skillLevels || [];
			state.technicianDetails.rateLevels || [];
		},
		[ADD_SKILL_TO_EMPLOYEE](state, skill) {
			state.technicianDetails.skillLevels =
				state.technicianDetails?.skillLevels ?? [];

			const existingSkill = state.technicianDetails.skillLevels?.find(
				s => s.id === skill.id
			);
			if (!existingSkill) {
				state.technicianDetails.skillLevels.push({
					id: skill.id,
					code: skill.code,
					description: skill.description,
					rateLevelId: skill.rateLevelId || 0,
					skillSetsId: skill.skillSetsId,
					techLevel: skill.techLevel || ''
				});
			} else {
				existingSkill.code = skill.code;
				existingSkill.description = skill.description;
				existingSkill.rateLevelId = skill.rateLevelId || 0;
				existingSkill.techLevel = skill.techLevel || '';
			}
		},
		[REMOVE_SKILL_FROM_EMPLOYEE](state, skill) {
			state.technicianDetails.skillLevels = state.technicianDetails.skillLevels.filter(
				s => s.id !== skill.id
			);
		},
		[ADD_RATE_TO_EMPLOYEE](state, rate) {
			const existingRate = state.technicianDetails.rateLevels.find(
				r => r.id === rate.id
			);
			const hourlyRate = rate.useCompanyDefault
				? rate.hourlyRate
				: rate.tempHourlyRate || 0;
			if (!existingRate) {
				state.technicianDetails.rateLevels.push({
					id: rate.id,
					code: rate.code,
					description: rate.description,
					hourlyRate: rate.hourlyRate,
					useCompanyDefault: rate.useCompanyDefault,
					tempHourlyRate: rate.tempHourlyRate
				});
			} else {
				existingRate.code = rate.code;
				existingRate.description = rate.description;
				(existingRate.hourlyRate = hourlyRate),
					(existingRate.useCompanyDefault = rate.useCompanyDefault);
				existingRate.tempHourlyRate = rate.tempHourlyRate;
			}
		},
		[CLEAR_DATA_FROM_EMPLOYEE](state) {
			state.technicianDetails = {};
		},
		[ADD_DEFAULT_HOURLY_RATE_TO_EMPLOYEE](state, defaultHourlyRate) {
			state.technicianDetails.defaultHourlyRate = defaultHourlyRate;
		},
		[SET_SEARCHLISTRESULTS](state, { query, searchResults }) {
			state.searchListResults.push({ query, searchResults });
		},
		[SET_SEARCHRESULTS](state, searchResults) {
			state.searchResults = searchResults;
		},
		[CLEAR_SEARCHLISTRESULTS](state) {
			state.searchListResults = [];
			state.searchResults = [];
		},
		[SET_SELECTEDTECHNICIANS](state, { selectedEmployees, checked }) {
			if (checked) {
				state.selectedTechnicians = [
					...state.selectedTechnicians,
					...selectedEmployees.filter(
						newTech =>
							!state.selectedTechnicians.some(
								existingTech => existingTech.id === newTech.id
							)
					)
				];
			} else {
				state.selectedTechnicians = state.selectedTechnicians.filter(
					existingTech =>
						!selectedEmployees.some(
							newTech => newTech.id === existingTech.id
						)
				);
			}
		},
		[CLEAR_SELECTEDTECHNICIANS](state) {
			state.selectedTechnicians = [];
		},
		[UPDATE_SELECTEDTECHNICIANS](state, selectedTechnician) {
			const existItem = state.selectedTechnicians.findIndex(
				technician => technician.id === selectedTechnician.id
			);
			existItem > -1
				? state.selectedTechnicians.splice(existItem, 1)
				: state.selectedTechnicians.push(selectedTechnician);
		},
		[SORT_POSITIONS](state) {
			//Order the positions alphabetically
			state.technicianSkills?.items.forEach(item => {
				item.positions.sort((position1, position2) =>
					position2.positionAbbreviation.localeCompare(
						position1.positionAbbreviation
					)
				);
			});
		},
		[ADD_INFO_TECHNICIAN_RATE](state) {
			state.technicianDetails.rateLevels.forEach(existingRate => {
				existingRate.useCompanyDefault = false;
				existingRate.tempHourlyRate = existingRate.hourlyRate;
			});
		},
		[SET_BULKTRANSACTIONPROCESSING](state, isProcessing) {
			state.bulkTransactionProcessing = isProcessing;
		},
		[UPDATE_TECHNICIANSKILLS_SKILLLEVELS](state, selectedTechnician) {
			const existingTech = state.technicianSkills?.items?.find(
				s => s.id === selectedTechnician.id
			);
			const existingTechSelected = state.selectedTechnicians?.find(
				s => s.id === selectedTechnician.id
			);
			if (existingTech) {
				existingTech.skillLevels = cloneDeep(
					selectedTechnician.skillLevels
				);
			}
			if (existingTechSelected) {
				existingTechSelected.skillLevels = cloneDeep(
					selectedTechnician.skillLevels
				);
			}
			state.searchListResults = [];
		},
		////////////////////////////////////////////////////////////////////////////////////////////////////////
		[UPDATE_TECHNICIANSKILLS_SKILLLEVELS_BULK](state, savedTechnicians) {
			savedTechnicians.forEach(selectedTechnician => {
				const existingTech = state.technicianSkills?.items?.find(
					s => s.id === selectedTechnician.id
				);
				if (existingTech) {
					existingTech.skillLevels = unionBy(
						state.technicianDetails.skillLevels,
						existingTech.skillLevels,
						'id'
					);
				}
			});
			if (savedTechnicians.length > 0) state.searchListResults = [];
		},
		[CLEAR_UNSAVED_BULK_ITEMS](state) {
			state.unsavedBulkItems = [];
		},
		[CLEAR_SAVED_BULK_ITEMS](state) {
			state.savedBulkItems = [];
		},
		[CLEAR_SKILLSETS_BULK_ITEMS](state) {
			state.skillSetsBulkItems = [];
		},
		[SET_UNSAVED_BULK_ITEMS](state, { selectedTechnician, transaction }) {
			const existingId = state.unsavedBulkItems.find(
				s => s.technician.id === selectedTechnician.id
			);
			if (existingId) {
				existingId.statusCode = transaction.statusCode;
				existingId.message = transaction.message;
			} else {
				state.unsavedBulkItems.push({
					technician: selectedTechnician,
					statusCode: transaction.statusCode,
					message: transaction.message
				});
			}
		},
		[SET_SAVED_BULK_ITEMS](state, selectedTechnicianId) {
			const existingId = state.savedBulkItems.find(
				s => s.id === selectedTechnicianId
			);
			if (!existingId) {
				state.savedBulkItems.push({ id: selectedTechnicianId });
			}
		},
		[SET_SKILLSETS_BULK_ITEMS](state, selectedSkills) {
			state.skillSetsBulkItems = cloneDeep(selectedSkills) || [];
		},
		[CLEAR_ERROR_MESSAGE_BULK_ITEMS](state) {
			state.errorMessageList = null;
		},
		[SET_ERROR_MESSAGE_BULK_ITEMS](state) {
			let items = state.unsavedBulkItems;
			state.errorMessageList = {
				statusCode: items[0]?.statusCode || '',
				message: items[0]?.message || '',
				technicianNames: items
					.map(
						t =>
							`${t.technician.firstName} ${t.technician.lastName}`
					)
					.join(', '),
				errorTechnicianslength: items.length,
				totalTechnicians: state.selectedTechnicians.length
			};
		},
		[CLEAR_SAVEDTECHNICIANS_BULK_ITEMS](state) {
			if (state.savedBulkItems.length > 0) {
				state.selectedTechnicians = state.selectedTechnicians.filter(
					selectedTechnician =>
						!state.savedBulkItems.some(
							savedBulkItem =>
								savedBulkItem.id === selectedTechnician.id
						)
				);
			}
		}
	},
	actions: {
		async getTechnicianSkillsAction({ commit }, companyId) {
			let technicianSkillsList = await api.get(
				buildRoute('/service/company/{companyId}/technicians', {
					companyId: companyId
				})
			);
			commit(SET_TECHNICIANSKILLS, technicianSkillsList);
			commit(SORT_POSITIONS);
			commit(CLEAR_SEARCHLISTRESULTS);
			commit(CLEAR_SELECTEDTECHNICIANS);
			return technicianSkillsList;
		},
		async getSkillSetsAction({ commit }, companyId) {
			const skillSets = await api.get(
				buildRoute('/service/company/{companyId}/skillsets', {
					companyId: companyId
				})
			);
			commit(SET_SKILLSETS_RESULT, skillSets);
			return skillSets;
		},
		async getRateLevelsAction({ commit }, companyId) {
			const rateLevels = await api.get(
				buildRoute('/service/company/{companyId}/ratelevels', {
					companyId: companyId
				})
			);
			commit(SET_RATELEVELS, rateLevels);
			return rateLevels;
		},
		async getTechnicianDetailsAction(
			{ commit },
			{ companyId, employeeId }
		) {
			const technicianDetails = await api.get(
				buildRoute(
					'/service/company/{companyId}/technician/{employeeId}',
					{
						companyId: companyId,
						employeeId: employeeId
					}
				)
			);
			commit(SET_TECHNICIAN_DETAILS, technicianDetails);
			commit(ADD_INFO_TECHNICIAN_RATE);
			return technicianDetails;
		},
		async getInitBulkAssignAction({ commit }) {
			commit(SET_TECHNICIAN_DETAILS, { skillLevels: [] });
		},
		async getSearchListAction(
			{ commit, state },
			{ searchData, selectedDepartments, sortColumn }
		) {
			const query = {
				searchData: searchData,
				selectedDepartments: selectedDepartments,
				sortColumn: sortColumn
			};
			let searchResults =
				state.searchListResults.find(sr =>
					areEqualElements(
						{
							searchData,
							selectedDepartments,
							sortColumn
						},
						sr.query
					)
				)?.searchResults || [];

			if (
				!(searchResults.length > 0) &&
				(searchData || selectedDepartments)
			) {
				let searchItems = state.technicianSkills?.items;
				searchResults =
					filterItems(searchItems, searchData, selectedDepartments) ||
					[];
				commit(SET_SEARCHLISTRESULTS, { query, searchResults });
				commit(SET_SEARCHRESULTS, searchResults);
			} else {
				commit(SET_SEARCHRESULTS, searchResults);
			}
		},
		setSelectedAllItemsAction({ commit }, { selectedEmployees, checked }) {
			if (selectedEmployees?.length > 0) {
				commit(SET_SELECTEDTECHNICIANS, { selectedEmployees, checked });
			}
		},
		setSelectedTechnicianAction({ commit }, selectedTechnician) {
			if (selectedTechnician) {
				commit(UPDATE_SELECTEDTECHNICIANS, selectedTechnician);
			}
		},
		async saveBulkAssignAction({ commit, state }, { companyId }) {
			let items = [];
			let skillLevels = state.technicianDetails?.skillLevels.map(
				level => {
					return {
						skillSetLevelsId: level.id,
						defaultRate: level.rateLevelId === 0,
						rateLevelId: level.rateLevelId,
						techLevel: level.techLevel,
						isActive: true
					};
				}
			);
			const mapSkillLevelsToItems = (skillLevels, technicians) => {
				return technicians.map(technician => ({
					id: technician.id,
					skillLevels: skillLevels.map(level => ({
						...level,
						employeeId: technician.id
					}))
				}));
			};
			let areEqual = areEqualElements(
				state.skillSetsBulkItems,
				skillLevels
			);

			if (!areEqual) {
				// there are new skillsets to save or delete

				items = mapSkillLevelsToItems(
					skillLevels,
					state.selectedTechnicians
				);
				commit(CLEAR_SAVED_BULK_ITEMS);
			} else if (state.unsavedBulkItems?.length > 0) {
				//there are unsaved items and is the same skillset
				items = mapSkillLevelsToItems(
					skillLevels,
					state.unsavedBulkItems.map(item => item.technician)
				);
			}
			let saveBulkAssign = await api.post(
				buildRoute('/service/company/{companyId}/technicians/', {
					companyId: companyId
				}),
				{ items }
			);

			if (items.length === saveBulkAssign?.items.length) {
				commit(CLEAR_UNSAVED_BULK_ITEMS);
				commit(CLEAR_ERROR_MESSAGE_BULK_ITEMS);
				commit(SET_SKILLSETS_BULK_ITEMS, skillLevels);
				saveBulkAssign?.items.forEach((transaction, index) => {
					const selectedTechnicianId = items[index].id;
					const selectedTechnician = state.selectedTechnicians.find(
						s => s.id === selectedTechnicianId
					);
					transaction?.statusCode === 200
						? commit(SET_SAVED_BULK_ITEMS, selectedTechnicianId)
						: commit(SET_UNSAVED_BULK_ITEMS, {
								selectedTechnician,
								transaction
						  });
				});
				if (state.unsavedBulkItems.length === 0) {
					commit(
						UPDATE_TECHNICIANSKILLS_SKILLLEVELS_BULK,
						state.selectedTechnicians
					);
					commit(CLEAR_SELECTEDTECHNICIANS);
					commit(CLEAR_SKILLSETS_BULK_ITEMS);
					commit(CLEAR_SAVED_BULK_ITEMS);
					commit(SET_TECHNICIAN_DETAILS, { skillLevels: [] });
					return true;
				} else {
					commit(
						UPDATE_TECHNICIANSKILLS_SKILLLEVELS_BULK,
						state.savedBulkItems
					);
					commit(SET_ERROR_MESSAGE_BULK_ITEMS);
					return false;
				}
			} else {
				return false;
			}
		},
		resetBulkItemsAction({ commit }) {
			commit(CLEAR_SAVEDTECHNICIANS_BULK_ITEMS); //remove the saved technicians from the selected technicians
			commit(CLEAR_SKILLSETS_BULK_ITEMS);
			commit(CLEAR_SAVED_BULK_ITEMS);
			commit(CLEAR_UNSAVED_BULK_ITEMS);
			commit(CLEAR_ERROR_MESSAGE_BULK_ITEMS);
			commit(SET_TECHNICIAN_DETAILS, { skillLevels: [] });
		},
		async saveSingleAssignAction(
			{ commit, state },
			{ companyId }
		) {
			let saveSingleAssignAction = {
				statusCode: 0,
				message: 'Error saving technician'
			};
			const employeeId = state.technicianDetails.id;
			let skillLevels = state.technicianDetails.skillLevels.map(level => {
				return {
					employeeId: employeeId,
					skillSetLevelsId: level.id,
					defaultRate: level.rateLevelId === 0,
					rateLevelId: level.rateLevelId,
					techLevel: level.techLevel,
					isActive: true
				};
			});
			let rateLevelsresult = state.technicianDetails.rateLevels
				.filter(r => r.useCompanyDefault == false)
				.map(level => {
					return {
						employeeId: employeeId,
						rateLevelId: level.id,
						hourlyRate: level.hourlyRate,
						isActive: true
					};
				});

			saveSingleAssignAction = await api.post(
				buildRoute('/service/company/{companyId}/technician', {
					companyId: companyId
				}),
				{
					id: employeeId,
					defaultHourlyRate: state.technicianDetails.defaultHourlyRate || 0,
					skillLevels: skillLevels,
					rateLevels: rateLevelsresult
				}
			);
			if (saveSingleAssignAction?.statusCode === 200) {
				commit(
					UPDATE_TECHNICIANSKILLS_SKILLLEVELS,
					state.technicianDetails
				);
				commit(CLEAR_DATA_FROM_EMPLOYEE);
			}
			return saveSingleAssignAction;
		},
		addSkillToEmployeeAction({ commit }, skill) {
			commit(ADD_SKILL_TO_EMPLOYEE, skill);
		},
		removeSkillFromEmployeeAction({ commit }, skill) {
			commit(REMOVE_SKILL_FROM_EMPLOYEE, skill);
		},
		addRateToEmployeeAction({ commit }, rate) {
			commit(ADD_RATE_TO_EMPLOYEE, rate);
		},
		setBulkTransactionProcessingAction({ commit }, isProcessing) {
			commit(SET_BULKTRANSACTIONPROCESSING, isProcessing);
		},
		addDefaultHourlyRateToEmployeeAction({ commit }, defaultHourlyRate) {
			commit(ADD_DEFAULT_HOURLY_RATE_TO_EMPLOYEE, defaultHourlyRate);
		}
	},
	getters: {
		skillSets: state => state.skillSets,
		rateLevels: state => state.rateLevels,
		technicianDetails: state => state.technicianDetails,
		technicianSkills: state => state.technicianSkills,
		searchResults: state => state.searchResults,
		searchListResults: state => state.searchListResults,
		selectedTechnicians: state => state.selectedTechnicians,
		bulkTransactionProcessing: state => state.bulkTransactionProcessing,
		errorMessageList: state => state.errorMessageList
	}
};
